import Box from '@mui/material/Box';
import {
  DialogBodyStandard,
  DialogBodyStandardProps,
} from './DialogBodyStandard';
import { LoadingButton } from '../buttons/LoadingButton';
import Button from '@mui/material/Button';

export type DialogBodyConfirmationProps = DialogBodyStandardProps & {
  onConfirm: () => Promise<void>;
  onCancel: () => void;
};

export function DialogBodyConfirmation({
  title,
  description,
  children,
  onCancel,
  onConfirm,
}: DialogBodyConfirmationProps) {
  return (
    <DialogBodyStandard title={title} description={description}>
      {children}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-around',
          gap: 2,
          width: '100%',
        }}
      >
        <LoadingButton
          variant="contained"
          color="secondary"
          onClick={onConfirm}
          sx={{ width: '100%' }}
        >
          Confirm
        </LoadingButton>
        <Button
          variant="contained"
          color="error"
          onClick={onCancel}
          sx={{ width: '100%' }}
        >
          Cancel
        </Button>
      </Box>
    </DialogBodyStandard>
  );
}
